module.exports = __webpack_public_path__ + "d9e420a6f1c84eb8bf093a13aadbd8cd.svg";